import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux'
import Select, { components } from 'react-select'
import * as d3 from 'd3'

const colorScheme = (d,i) => {
    const colorScale = d3.scaleSequential()
        .domain([5, 0])
        .interpolator(d3.interpolateCool)
    return colorScale(d)
}
const DropdownLayers = props => {
    const { layersDispatch, optionsMulti } = props
    const dispatch = useDispatch()
    const [options, setOptions] = useState(optionsMulti)
    const formatOptionLabel = props => {
        const { innerRef, innerProps } = props;
        const handleAddedLayer = e => {
            const view = layersDispatch.view
            dispatch.layers.loadDatabaseLines({ ...props, view });
        }
        return (
            <div
                ref={innerRef}
                {...innerProps}
                onClick={(e) => {
                    // innerProps.onClick(e); // Keep the default select behavior
                    handleAddedLayer(e);  // Run your custom code
                }}
                style={{  cursor: 'pointer', marginRight: '3px' }}
            >
                {props.label}
            </div>
        );
    };
    const customStyles = {
        multiValue: (styles, { data }) => {
            const visibleOption = layersDispatch.visibleVectors
            return {
                ...styles,
                backgroundColor: visibleOption[data.value]  ? '#EFF5FF' : '#E6E6E6',
                border: `1px solid ${visibleOption[data.value] ? '#3b82f6' : '#cccccc'}`, // Conditional color
                // cursor: data.value === 'parcels' ? 'not-allowed' : 'default',
            };
        },
        multiValueRemove: base => ({
            ...base,
            display: 'none'
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: 'white',
            borderColor: 'white',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
            '&:hover': {
                borderColor: state.isFocused ? '#3b82f6' : '#9ca3af',
            },
            borderRadius: '8px',
            padding: '2px',
        }),
    };
    const onChange = val => {
    }
    const handleChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'remove-value' || actionMeta.action === 'pop-value') {
            return
        }
        setOptions(newValue);
    };
    return (
        <div className='layers-select'>
            <Select
                isMulti
                isClearable={false}
                closeMenuOnSelect={false}
                // components={{ Option: CustomOption }}
                options={ options }
                styles={ customStyles }
                defaultValue={ [options[0],options[1], options[2], options[3], options[4], options[5], options[6]] }
                formatOptionLabel={  formatOptionLabel }
                onChange={ handleChange }
                className="basic-multi-select"
                classNamePrefix="select"
            />
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        layersDispatch: dispatch.layers
    })
)

export default connect(mapStateToProps)(DropdownLayers)
